module.exports = __webpack_public_path__ + "img/outfield-mezzanine.845d9823.svg";